 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"default-app-bar~layout-auth-Index":"default-app-bar~layout-auth-Index","layout-auth-Index":"layout-auth-Index","layout-default-Index":"layout-default-Index","views-Dashboard~views-Files~views-Folder~views-Login~views-Recieved~views-Register~views-UserProfile~106ad044":"views-Dashboard~views-Files~views-Folder~views-Login~views-Recieved~views-Register~views-UserProfile~106ad044","default-account~views-Dashboard~views-Files~views-Folder~views-Recieved~views-Users":"default-account~views-Dashboard~views-Files~views-Folder~views-Recieved~views-Users","views-Dashboard~views-Files~views-Folder~views-Recieved~views-Users":"views-Dashboard~views-Files~views-Folder~views-Recieved~views-Users","views-Dashboard~views-Users":"views-Dashboard~views-Users","views-Dashboard":"views-Dashboard","views-Users":"views-Users","views-Files~views-Folder~views-Notifications~views-Recieved":"views-Files~views-Folder~views-Notifications~views-Recieved","views-Files":"views-Files","views-Folder":"views-Folder","views-Recieved":"views-Recieved","views-Login~views-Register":"views-Login~views-Register","views-Login":"views-Login","views-Register":"views-Register","views-UserProfile":"views-UserProfile","views-Error":"views-Error","views-Notifications":"views-Notifications","default-app-bar":"default-app-bar","default-drawer":"default-drawer","default-footer":"default-footer","default-view":"default-view","default-account":"default-account","default-drawer-toggle":"default-drawer-toggle","default-drawer-header":"default-drawer-header","default-list":"default-list"}[chunkId]||chunkId) + "." + {"default-app-bar~layout-auth-Index":"b25da566","layout-auth-Index":"e9076d84","layout-default-Index":"5c80e3b8","views-Dashboard~views-Files~views-Folder~views-Login~views-Recieved~views-Register~views-UserProfile~106ad044":"35c09364","default-account~views-Dashboard~views-Files~views-Folder~views-Recieved~views-Users":"cc39151d","views-Dashboard~views-Files~views-Folder~views-Recieved~views-Users":"4adee743","views-Dashboard~views-Users":"8ff58398","views-Dashboard":"f199bdcf","views-Users":"ba023d20","views-Files~views-Folder~views-Notifications~views-Recieved":"9ead093b","views-Files":"4d3d07c8","views-Folder":"8081866a","views-Recieved":"5bae3343","views-Login~views-Register":"5bf4e2b3","views-Login":"f50fcbdd","views-Register":"d0f7747d","views-UserProfile":"36e911f7","views-Error":"668d90a5","views-Notifications":"50c45466","chunk-6ff5e40f":"5a9450bd","default-app-bar":"d3f80af5","default-drawer":"96f92044","default-footer":"32186ef2","default-view":"2dfcab92","default-account":"411f9fc6","default-drawer-toggle":"8ac917c8","default-drawer-header":"5ed98ee7","default-list":"18bf5674","chunk-72889448":"f5811354","chunk-7772b77c":"eb4277e7","chunk-2d21e5a6":"a55efc8e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"default-app-bar~layout-auth-Index":1,"layout-auth-Index":1,"layout-default-Index":1,"views-Dashboard~views-Files~views-Folder~views-Login~views-Recieved~views-Register~views-UserProfile~106ad044":1,"default-account~views-Dashboard~views-Files~views-Folder~views-Recieved~views-Users":1,"views-Dashboard~views-Files~views-Folder~views-Recieved~views-Users":1,"views-Dashboard~views-Users":1,"views-Files~views-Folder~views-Notifications~views-Recieved":1,"views-Files":1,"views-Folder":1,"views-Recieved":1,"views-Login~views-Register":1,"views-UserProfile":1,"views-Error":1,"chunk-6ff5e40f":1,"default-drawer":1,"default-footer":1,"default-view":1,"default-drawer-header":1,"default-list":1,"chunk-72889448":1,"chunk-7772b77c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"default-app-bar~layout-auth-Index":"default-app-bar~layout-auth-Index","layout-auth-Index":"layout-auth-Index","layout-default-Index":"layout-default-Index","views-Dashboard~views-Files~views-Folder~views-Login~views-Recieved~views-Register~views-UserProfile~106ad044":"views-Dashboard~views-Files~views-Folder~views-Login~views-Recieved~views-Register~views-UserProfile~106ad044","default-account~views-Dashboard~views-Files~views-Folder~views-Recieved~views-Users":"default-account~views-Dashboard~views-Files~views-Folder~views-Recieved~views-Users","views-Dashboard~views-Files~views-Folder~views-Recieved~views-Users":"views-Dashboard~views-Files~views-Folder~views-Recieved~views-Users","views-Dashboard~views-Users":"views-Dashboard~views-Users","views-Dashboard":"views-Dashboard","views-Users":"views-Users","views-Files~views-Folder~views-Notifications~views-Recieved":"views-Files~views-Folder~views-Notifications~views-Recieved","views-Files":"views-Files","views-Folder":"views-Folder","views-Recieved":"views-Recieved","views-Login~views-Register":"views-Login~views-Register","views-Login":"views-Login","views-Register":"views-Register","views-UserProfile":"views-UserProfile","views-Error":"views-Error","views-Notifications":"views-Notifications","default-app-bar":"default-app-bar","default-drawer":"default-drawer","default-footer":"default-footer","default-view":"default-view","default-account":"default-account","default-drawer-toggle":"default-drawer-toggle","default-drawer-header":"default-drawer-header","default-list":"default-list"}[chunkId]||chunkId) + "." + {"default-app-bar~layout-auth-Index":"2f74ea7a","layout-auth-Index":"54aedb73","layout-default-Index":"d3635ab2","views-Dashboard~views-Files~views-Folder~views-Login~views-Recieved~views-Register~views-UserProfile~106ad044":"771c4999","default-account~views-Dashboard~views-Files~views-Folder~views-Recieved~views-Users":"9b262b18","views-Dashboard~views-Files~views-Folder~views-Recieved~views-Users":"56ccc5fe","views-Dashboard~views-Users":"39e72152","views-Dashboard":"31d6cfe0","views-Users":"31d6cfe0","views-Files~views-Folder~views-Notifications~views-Recieved":"6a47d9f4","views-Files":"e5803d79","views-Folder":"ecb89ced","views-Recieved":"d3de4bc2","views-Login~views-Register":"8b8f4869","views-Login":"31d6cfe0","views-Register":"31d6cfe0","views-UserProfile":"d0e7916e","views-Error":"41c12922","views-Notifications":"31d6cfe0","chunk-6ff5e40f":"f4f2c1ce","default-app-bar":"31d6cfe0","default-drawer":"9a24782f","default-footer":"de049660","default-view":"f4f2c1ce","default-account":"31d6cfe0","default-drawer-toggle":"31d6cfe0","default-drawer-header":"aa41f2ec","default-list":"c0aba782","chunk-72889448":"31e4886e","chunk-7772b77c":"31e4886e","chunk-2d21e5a6":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
